module.exports = __webpack_public_path__ + "img/LoginCard-right-old.c49618f1.png";